import {Spin, TabsProps} from "antd";
import {HistoryExamine, Tabs} from "components/common";
import React, {Suspense, useEffect} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
// import ComeInHospitalInfo from "./tabs/ComeInHospitalInfo/ComeInHospitalInfo";
// import TreatmentInfo from "./tabs/TreatmentInfo/TreatmentInfo";
// import ComeOutHospitalInfo from "./tabs/ComeOutHospitalInfo/ComeOutHospitalInfo";
import SickBedCatalog from "./tabs/SickBedCatalog/SickBedCatalog";
import {residentialNurse} from "types/enums/residential-nurse";
import ListPatient from "./tabs/ListPatient/ListPatient";
import {reloadData} from "redux/reducer/residentialNurse";
import {setActiveKey, setSiderKey} from "redux/reducer/common";

const TreatmentInfo = React.lazy(
  () => import("./tabs/TreatmentInfo/TreatmentInfo")
);
const ComeInHospitalInfo = React.lazy(
  () => import("./tabs/ComeInHospitalInfo/ComeInHospitalInfo")
);
const ComeOutHospitalInfo = React.lazy(
  () => import("./tabs/ComeOutHospitalInfo/ComeOutHospitalInfo")
);
const Nursing = () => {
  const idDDNT = useAppSelector(state => state.residentialNurse.idDDNT);
  document.title = "Điều dưỡng nội trú";
  const items: TabsProps["items"] = [
    {
      key: residentialNurse.NURSING.LIST_PATIENT,
      label: "Danh sách bệnh nhân",
      children: <ListPatient />,
    },
    {
      key: residentialNurse.NURSING.COME_IN_HOSPITAL_INFO,
      label: "Thông tin nhập viện",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <ComeInHospitalInfo />
        </Suspense>
      ),
      disabled: idDDNT || idDDNT === 0 ? false : true,
    },
    {
      key: residentialNurse.NURSING.TREATMENT_INFO,
      label: "Thông tin điều trị",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <TreatmentInfo />
        </Suspense>
      ),
      disabled: idDDNT || idDDNT === 0 ? false : true,
    },
    {
      key: residentialNurse.NURSING.COME_OUT_HOSPITAL_INFO,
      label: "Thông tin xuất viện",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <ComeOutHospitalInfo />
        </Suspense>
      ),
      disabled: idDDNT || idDDNT === 0 ? false : true,
    },
    {
      key: residentialNurse.NURSING.EXAMINE_HISTORY,
      label: "Lịch sử khám bệnh",
      children: <HistoryExamine />,
      disabled: idDDNT || idDDNT === 0 ? false : true,
    },
    {
      key: residentialNurse.NURSING.SICK_BED_CATALOG,
      label: "Danh mục giường bệnh",
      children: <SickBedCatalog />,
    },
  ];

  const activeTab = useAppSelector(e => e.common.activeTab);
  let dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setActiveKey(residentialNurse.NURSING.LIST_PATIENT));
    dispatch(reloadData());
    dispatch(setSiderKey("dieuDuongNoiTru"));
  }, []);
  useEffect(() => {}, [idDDNT]);
  return (
    <div className="residential-nurse page">
      <div className="main">
        <Tabs items={items} activeKey={activeTab} />
      </div>
    </div>
  );
};

export default Nursing;
